import React from 'react';
import classNames from 'classnames';
import get from 'lodash/get';

import propTypes from 'prop-types';
import { getAnalytics } from '../analytics';
import IconArrow from '!svg-react-loader?!images-react-svg/icons/button-arrow.svg';

const DEFAULT_PROCESSING_TEXT_KEY = 'common.forms.buttons.pending';
const DEFAULT_PROCESSING_TEXT = get(global, [
  'translations',
  'messages',
  DEFAULT_PROCESSING_TEXT_KEY,
]);

class Button extends React.Component {
  static propTypes = {
    children: propTypes.node,
    element: propTypes.oneOfType([
      propTypes.element,
      propTypes.func,
      propTypes.node,
      propTypes.elementType,
    ]),
    href: propTypes.string,
    target: propTypes.string,
    onClick: propTypes.func,
    processing: propTypes.bool,
    processingText: propTypes.string,
    type: propTypes.string,
    value: propTypes.string,
    analyticsEventName: propTypes.string,
    analyticsEventData: propTypes.object,
  };

  static defaultProps = {
    element: 'button',
    processingText: DEFAULT_PROCESSING_TEXT,
    disabled: false,
  };

  trackClick = el => {
    const { analyticsEventName, analyticsEventData, element } = this.props;
    if (!analyticsEventName) {
      return;
    }

    if (element === 'a') {
      getAnalytics().trackLink(el, analyticsEventName, analyticsEventData);
    } else {
      getAnalytics().track(analyticsEventName, analyticsEventData);
    }
  };

  handleClick = e => {
    const { disabled, onClick } = this.props;
    if (disabled) {
      // this naturally happens for button tags, but not for others tags/components
      e.preventDefault();
    } else {
      onClick && onClick(e);
    }
  };

  render() {
    const {
      children,
      disabled,
      processing,
      processingText,
      element,
      // Exclude analytics props from being sent down to child components as
      // they are only understood in this parent component.
      analyticsEventData, // eslint-disable-line no-unused-vars
      analyticsEventName, // eslint-disable-line no-unused-vars
      ...props
    } = this.props;

    // Since the default <button> element can't have an href, we can assume we want an anchor tag.
    const Element = this.props.href ? 'a' : element;

    let buttonText = (
      <span className="button__text">
        {children}
        <IconArrow />
      </span>
    );

    if (processing) {
      buttonText = <Processing text={processingText} />;
    }

    return (
      <Element
        {...props}
        disabled={disabled || processing}
        onClick={this.handleClick}
        ref={this.trackClick}
        className={classNames('button', props.className)}
      >
        {buttonText}
      </Element>
    );
  }
}

const Processing = ({ text }) => (
  <div className="button__processing">
    <div className="Spinner button__processing__spinner" />
    {text && <div className="button__processing__text">{text}</div>}
  </div>
);

export default Button;
